module.exports = __webpack_public_path__ + "static/media/logout.cc38642d.svg";